import { Component, OnInit, OnDestroy, ElementRef, ViewChild } from "@angular/core";
import { Subscription, Subject, Observable, timer } from "rxjs";

import { WebcamImage, WebcamInitError } from "ngx-webcam";
import { ImageCroppedEvent, ImageTransform } from "ngx-image-cropper"; // https://github.com/Mawi137/ngx-image-cropper

import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared/services/user.service";
import { PersonSelectorService } from "../../personselector/personselector.service";

import { DataService_photostation } from "./shared/data.service";

import { wsPhotoStationPhotoInfo } from "./shared/wsPhotoStationPhotoInfo";
import { wsPhotoStationPhotoUploadInfoParm } from "./shared/wsPhotoStationPhotoUploadInfoParm";
import { wsPhotoStationSignatureUploadInfoParm } from "./shared/wsPhotoStationSignatureUploadInfoParm";
import { wsPhotoStationDataInfoParm } from "./shared/wsPhotoStationDataInfoParm";
import { wsPhotoStationDataInfo } from "./shared/wsPhotoStationDataInfo";
import { wsPhotoStationDataStudentInfo } from "./shared/wsPhotoStationDataInfo";
import { wsPhotoStationDataStaffInfo } from "./shared/wsPhotoStationDataInfo";
import { wsAiColorPickerParmInfo, wsAiColorPickerInfo, wsAiPresetColorInfo, wsAiColorPickerDefaultAIColorParmInfo,wsAiColorPickerDefaultAIColorInfo } from "./shared/wsPhotoAIColorPresetInfo";
import { wsPhotoAIUploadInfo } from "./shared/wsPhotoAIUploadInfo";

import { ColorPickerComponent, ColorPickerModule } from 'ngx-color-picker';
import { PrintComponent } from "./print/print.component";
import { ThLargeIcon } from "primeng/icons/thlarge";

//
// SigWebTablet.js (Interfaces)
//
declare const IsSigWebInstalled: Function;
declare const GetTabletState: Function;
declare const GetSigWebVersion: Function;
declare const GetDaysUntilCertificateExpires: Function;
declare const SetDisplayXSize: Function;
declare const SetDisplayYSize: Function;
declare const SetTabletState: Function;
declare const SetJustifyMode: Function;
declare const ClearTablet: Function;
declare const NumberOfTabletPoints: Function;
declare const SetSigCompressionMode: Function;
declare const SetImageXSize: Function;
declare const SetImageYSize: Function;
declare const SetImagePenWidth: Function;
declare const GetSigString: Function;
declare const Access411_GetSigImageB64: Function;

@Component({
	selector: "app-root",
	templateUrl: "./photostation.component.html",
	styleUrls: ["./photostation.component.css"],
	providers: [ConfirmationService, DialogService],
})
export class PhotoStationComponent implements OnInit, OnDestroy {
	@ViewChild('myCnv', { static: true }) myCnv!: ElementRef;

	constructor(
		private dataService: DataService_photostation,
		private userService: UserService,
		private confirmationService: ConfirmationService,
		private personselectorService: PersonSelectorService,
		private dialogService: DialogService
	) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Globals
	//
	//-----------------------------------------------------------------------------------------------------
	private title = "Photo Station";
	public user: any;
	
	// SigWeb
	private SigWeb_1_7_2_0_IsInstalled = false;   // SigWeb 1.7.2.0 and above required
	private tmr: any;
	private SigElement: any;
	private bioSigData: any;
	private bioSigDataBase64_jpg: any;
	private bioSigDataBase64_web: any;
	public isSigOnFile: boolean = false;

	// General	
	public isBusy: boolean = false;
	public isDisablePhotoSave: boolean = true;
	public isDisableSignatureSave: boolean = true;
	public QueueIsLocked: boolean = false;
	public LockoutMessage: string = "";	

	// AI
	public isAiShowColorPicker: boolean = false;
	public isAiProcessing: boolean = false;
	public isAiProcessed: boolean = false;
	public AiBackgroundColor: string = "#FFFFFF";
	public AiPresetColors: string[] = [];
	public AiResetImage: string;	

	// Hide/Show
	public isHideSelector: boolean = false;
	public isHidePhotoEdit: boolean = false;
	public isHideSugnatureInfo: boolean = false;
	public isHidePersonInfo: boolean = false;
	public isImageFromCAASS: boolean = true;
	public isImageFromCAASSRestore: boolean = false;
	public cropperDelayRefreshHack = timer(50);

	// Person Selector
	private subscriptionPersonSelect: Subscription;
	private subscriptionSchoolSelect: Subscription;
	private subscriptionPhotoClicked: Subscription;

	private SelectedPerson: any; // From Person Selector
	private SelectedSchool: any; // From Person Selector

	// WebCam
	private trigger: Subject<void> = new Subject<void>();
	public isCamError: boolean = false;
	public CamErrorMessage: string = "Failed to connect to Camera!";

	// PersonPhoto
	public PersonPhoto: wsPhotoStationPhotoInfo = {
		PersonID: -1,
		HasPhoto: true,
		ImageData_Normal: "",
		ImageData_Raw: "",
	};

	// PhotoStationData
	public PhotoStationDataStudentBlank = {} as wsPhotoStationDataStudentInfo;
	public PhotoStationDataStaffBlank = {} as wsPhotoStationDataStaffInfo;

	public PhotoStationData: wsPhotoStationDataInfo = {
		PersonID: -1,
		Name: "None",
		IsStaff: false,
		ActiveIDCardDesc: "None",
		StudentItems: this.PhotoStationDataStudentBlank,
		StaffItems: this.PhotoStationDataStaffBlank,
		BarcodeItems: [],
		SignatureData: ""
	};

	public PhotoStationSignatureData: wsPhotoStationSignatureUploadInfoParm = {
		PersonID: -1,
		SignatureData: ""
	};

	public AiColorPicker: wsAiColorPickerInfo = {
		SchoolID: -1,
		DefaultAIColor: "",
		PresetAIColorList: []
	}; 

	// Update Raw For WebCam or FileLoad only
	public isUpdateRaw: boolean = false;

	//	Image Processing
	public cropperImageBase64: any = "";
	public cropperCroppedImage: any = "";
	public cropperCroppedWorkImage: any = "";
	public cropperMaintainAspectRatio: boolean = false;
	public cropperAspectRatio: number = 1.0;
	public cropperCanvasRotation: number = 0.0;
	public cropperTransform: ImageTransform = {};

	public isCustom: boolean = true;
	public isLandscape: boolean = false;
	public isPortrait: boolean = false;

	public filterGrayscale: boolean = false;
	public filterBrightness: number = 0.0;
	public filterContrast: number = 0.0;

	//	Barcode Counts
	public pagefirst: number = 0;
	public pagerows: number = 10;
	public isShowEmbedded: boolean = false;
	public isShowExpire: boolean = false;

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnInit
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnInit() 
	{
		this.user = this.userService.getCurrentUser();

		//
		//	Start SigWeb
		//		
		if(IsSigWebInstalled())
		{
			this.SigElement = this.myCnv.nativeElement.getContext('2d');
			var SigWebVer = "";

			try
			{
				SigWebVer = GetSigWebVersion();
				console.log("SigWeb Version: " + SigWebVer);

			} catch(error)
			{
				console.log("Unable to get SigWeb Version: "+ error);
			}

			if(SigWebVer != "")
			{		
				try 
				{
					this.SigWeb_1_7_2_0_IsInstalled = this.isSigWeb_1_7_2_0_OrGreater_Installed(SigWebVer);
				
					if(this.SigWeb_1_7_2_0_IsInstalled)
					{
						try
						{
							var daysUntilCertExpires = GetDaysUntilCertificateExpires();
							console.log("SigWeb Certificate expires in "+ daysUntilCertExpires + " days.");
						} 
						catch(error)
						{
							console.log(error);
						};
					}          
				} 
				catch(error)
				{
					console.log("Unable to get SigWeb Version: "+ error);
				};
			}
		}
		else
		{
			console.log("Unable to communicate with TOPAZ SigWeb. Please confirm that SigWeb is installed and running on a Windows PC.");
		}    
		
		//
		//	Start Subscriptions
		//
		this.subscriptionPersonSelect = this.personselectorService.onPersonSelectChange().subscribe((person) => 
		{
			this.SelectedPerson = person;

			if (this.SelectedPerson.PersonID > 0) 
			{
				let parms: wsPhotoStationPhotoInfo = 
				{
					PersonID: this.SelectedPerson.PersonID,
					HasPhoto: false,
					ImageData_Normal: "",
					ImageData_Raw: "",
				};

				let parmsData: wsPhotoStationDataInfoParm = 
				{
					PersonID: this.SelectedPerson.PersonID,
					SchoolID: this.SelectedPerson.SchoolID,
				};

				this.isDisablePhotoSave = true;
				this.isDisableSignatureSave = true;
				this.dataService.PhotoStationPhotoGet(parms).subscribe((data) => this.PhotoStationPhotoGet_Complete(data));
				this.dataService.PhotoStationDataGet(parmsData).subscribe((data) => this.PhotoStationDataGet_Complete(data));
			} 
			else 
			{
				this.PersonPhoto.PersonID = -1;
				this.PersonPhoto.HasPhoto = false;
				this.PersonPhoto.ImageData_Normal = "";
				this.PersonPhoto.ImageData_Raw = "";

				this.PhotoStationData.PersonID = -1;
				this.PhotoStationData.Name = "None";
				this.PhotoStationData.IsStaff = false;
				this.PhotoStationData.ActiveIDCardDesc = "None";
				this.PhotoStationData.StudentItems = this.PhotoStationDataStudentBlank;
				this.PhotoStationData.StaffItems = this.PhotoStationDataStaffBlank;
				this.PhotoStationData.BarcodeItems = [];

				this.cropperImageBase64 = "";
				this.cropperCroppedWorkImage = "";
				this.isUpdateRaw = false;
				this.isDisablePhotoSave = true;
				this.isDisableSignatureSave = true;
				this.isImageFromCAASS = true;
				this.isImageFromCAASSRestore = false;
			}
		});

		this.subscriptionSchoolSelect = this.personselectorService.onSchoolSelectedChange().subscribe((school) => 
		{
			this.SelectedSchool = school;
			
			let parms: wsAiColorPickerDefaultAIColorParmInfo = 
			{
				SchoolID: this.SelectedSchool.SchoolID
			};
	
			this.dataService.AIColorPickerGetDefaultAIColor(parms).subscribe((data) => this.AIColorPickerGetDefaultAIColor_Complete(data));
		});
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ngOnDestroy
	//
	//-----------------------------------------------------------------------------------------------------
	ngOnDestroy() {
		this.subscriptionPersonSelect.unsubscribe();
		this.subscriptionSchoolSelect.unsubscribe();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleSelector
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleSelector() {
		this.isHideSelector = !this.isHideSelector;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onTogglePhotoEdit
	//
	//-----------------------------------------------------------------------------------------------------
	onTogglePhotoEdit() {
		this.isHidePhotoEdit = !this.isHidePhotoEdit;

		//	- HACK -
		//
		//	This is a hack to get around a bug in cropper when hiding the control and redesplaying it when
		// 	the image changes while cropper is hidden.
		//
		//	A timmer is needed to make this hack work. Some how there needs to be a delay between clearing the image and setting it.
		//	The clear is needed or the set will not be recognized.
		//
		//	The double timmer is needed or the hack will sometimes throw a cannot read property 'transformed' of
		//  null error, but is seems to recover without hindering the working of the cropper control.
		//
		//	Note: The delay time may need to be increased for slower conputers if the cropper image is blank apon going from
		//	a hidded state to a visable state.
		//
		//	- HACK -

		if (this.isHidePhotoEdit == false && this.isImageFromCAASS == true) {
			//
			//	If going from a hidden state to a visable state, then preform said hack...
			//
			this.cropperDelayRefreshHack.subscribe((x) => {
				this.cropperImageBase64 = "";

				this.cropperDelayRefreshHack.subscribe((x) => {
					if (this.isImageFromCAASSRestore == true) {
						this.cropperImageBase64 = this.PersonPhoto.ImageData_Raw;
					} else {
						this.cropperImageBase64 = this.PersonPhoto.ImageData_Normal;
					}
				});
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onToggleSignatureInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onToggleSignatureInfo() {
		this.isHideSugnatureInfo = !this.isHideSugnatureInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onTogglePersonInfo
	//
	//-----------------------------------------------------------------------------------------------------
	onTogglePersonInfo() {
		this.isHidePersonInfo = !this.isHidePersonInfo;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ontoggleEmbedded
	//
	//-----------------------------------------------------------------------------------------------------
	ontoggleEmbedded() {
		this.isShowEmbedded = !this.isShowEmbedded;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ontoggleExpire
	//
	//-----------------------------------------------------------------------------------------------------
	ontoggleExpire() {
		this.isShowExpire = !this.isShowExpire;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoStationPhotoGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoStationPhotoGet_Complete(data: any) {
		this.PersonPhoto = data;

		if (this.PersonPhoto.HasPhoto == true) {
			// Has A Photo In CAASS
			this.cropperImageBase64 = this.PersonPhoto.ImageData_Normal;
			this.isImageFromCAASS = true;
			this.isImageFromCAASSRestore = false;
			this.isUpdateRaw = false;
			this.isDisablePhotoSave = false;
		} else {
			// Has No Photo IN CAASS
			this.cropperImageBase64 = "";
			this.cropperCroppedWorkImage = "";
			this.isImageFromCAASS = true;
			this.isImageFromCAASSRestore = false;
			this.isUpdateRaw = false;
			this.isDisablePhotoSave = false;
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoStationDataGet_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoStationDataGet_Complete(data: any) {
		this.PhotoStationData = data;

		this.QueueIsLocked = data.QueueIsLocked;
		this.LockoutMessage = data.LockoutMessage;
		this.isDisableSignatureSave = false;

		if (this.PhotoStationData.SignatureData == null)
		{
			this.isSigOnFile = false;
		}
		else
		{
			if (this.PhotoStationData.SignatureData.length > 100)
			{
				this.isSigOnFile = true;
			}
			else
			{
				this.isSigOnFile = false;
			}
		}

		if (this.PhotoStationData.IsStaff == true) {
			this.PhotoStationData.StudentItems = this.PhotoStationDataStudentBlank; // Prevent HTML Error
		} else {
			this.PhotoStationData.StaffItems = this.PhotoStationDataStaffBlank; // Prevent HTML Error
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	camTriggerObservable
	//
	//-----------------------------------------------------------------------------------------------------
	public get camTriggerObservable(): Observable<void> {
		return this.trigger.asObservable();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	camTriggerSnapshot
	//
	//-----------------------------------------------------------------------------------------------------
	public camTriggerSnapshot(): void {
		this.trigger.next();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	camHandleImage
	//
	//-----------------------------------------------------------------------------------------------------
	public camHandleImage(webcamImage: WebcamImage): void {
		this.cropperImageBase64 = webcamImage.imageAsDataUrl;
		this.isImageFromCAASS = false;
		this.isUpdateRaw = true;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	camHandleInitError
	//
	//-----------------------------------------------------------------------------------------------------
	public camHandleInitError(error: WebcamInitError): void {
		if (error.mediaStreamError && error.mediaStreamError.name === "NotAllowedError") {
			this.isCamError = true;
			this.CamErrorMessage = "Camera access was not allowed by user!";
			console.warn(this.CamErrorMessage);
		}

		if (error.mediaStreamError && error.mediaStreamError.name === "NotFoundError") {
			this.isCamError = true;
			this.CamErrorMessage = "No Camera was found!";
			console.warn(this.CamErrorMessage);
		}

		if (error.mediaStreamError && error.mediaStreamError.name === "NotReadableError") {
			this.isCamError = true;
			this.CamErrorMessage = "Failed to connect to Camera!";
			console.warn(this.CamErrorMessage);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFileLoad
	//
	//-----------------------------------------------------------------------------------------------------
	onFileLoad(event: any) {
		if (this.SelectedSchool.SchoolID > 0) {
			if (event.target.files && event.target.files[0]) {
				let reader = new FileReader();

				reader.onload = (e: any) => {
					this.LoadAndResizeImage(event.target.files[0], e.target.result, 640, this);
				};

				reader.readAsDataURL(event.target.files[0]);
			}
		} else {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Please select a school before loading photo.",
				header: "School not selected",
				icon: "fa fa-external-link",
				accept: () => {},
				reject: () => {},
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	LoadAndResizeImage
	//
	//-----------------------------------------------------------------------------------------------------
	LoadAndResizeImage(imgfile: any, imgfiledata: any, MAX_SIZE: any, _this: this) {
		// Create work image for resizing
		let img = document.createElement("img");

		img.onerror = function () {
			console.log("ERROR: Invalid Image! -> ", imgfile.name);
		};

		img.onload = function () {
			let width = img.width;
			let height = img.height;

			if (width >= height) {
				// Landscape
				height = Math.round(img.height * (MAX_SIZE / img.width));
				width = MAX_SIZE;
			} else {
				// Portrait
				width = Math.round(img.width * (MAX_SIZE / img.height));
				height = MAX_SIZE;
			}

			let canvas = document.createElement("canvas");

			canvas.width = width;
			canvas.height = height;

			let ctx = canvas.getContext("2d");

			ctx.drawImage(img, 0, 0, width, height);

			let PhotoUrl = canvas.toDataURL("image/jpeg");

			_this.cropperImageBase64 = PhotoUrl;
			_this.isImageFromCAASS = false;
			_this.isUpdateRaw = true;
		};

		// Load The Image Data
		img.src = imgfiledata;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onCustom
	//
	//-----------------------------------------------------------------------------------------------------
	onCustom() {
		this.isCustom = true;
		this.isPortrait = false;
		this.isLandscape = false;
		this.cropperMaintainAspectRatio = false;
		this.cropperAspectRatio = 1.0 / 1.0;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPortrait
	//
	//-----------------------------------------------------------------------------------------------------
	onPortrait() {
		this.isCustom = false;
		this.isPortrait = true;
		this.isLandscape = false;
		this.cropperMaintainAspectRatio = true;
		this.cropperAspectRatio = 3.0 / 4.0;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onLandscape
	//
	//-----------------------------------------------------------------------------------------------------
	onLandscape() {
		this.isCustom = false;
		this.isPortrait = false;
		this.isLandscape = true;
		this.cropperMaintainAspectRatio = true;
		this.cropperAspectRatio = 4.0 / 3.0;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRotateCanvas
	//
	//-----------------------------------------------------------------------------------------------------
	onRotateCanvas() {
		let newRotation = this.cropperCanvasRotation + 1; // 0=0°, 1=90°, 2=180°, 3=270°

		if (newRotation > 3) {
			newRotation = 0;
		}

		this.cropperCanvasRotation = newRotation;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFlipImageH
	//
	//-----------------------------------------------------------------------------------------------------
	onFlipImageH() {
		this.cropperTransform = {
			...this.cropperTransform,
			flipH: !this.cropperTransform.flipH,
		};
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onFlipImageV
	//
	//-----------------------------------------------------------------------------------------------------
	onFlipImageV() {
		this.cropperTransform = {
			...this.cropperTransform,
			flipV: !this.cropperTransform.flipV,
		};
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRestore
	//
	//-----------------------------------------------------------------------------------------------------
	onRestore() {
		if (this.SelectedPerson.PersonID > 0) {
			let parms: wsPhotoStationPhotoInfo = {
				PersonID: this.SelectedPerson.PersonID,
				HasPhoto: false,
				ImageData_Normal: "",
				ImageData_Raw: "",
			};

			this.isDisablePhotoSave = true;
			this.dataService.PhotoStationPhotoGet(parms).subscribe((data) => this.onRestore_Complete(data));
		} else {
			// No Person Selected
			this.cropperImageBase64 = "";
			this.cropperCroppedWorkImage = "";
			this.isImageFromCAASS = true;
			this.isImageFromCAASSRestore = true;
			this.isUpdateRaw = false;
			this.isDisablePhotoSave = false;
			this.isAiProcessed = false;
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onRestore_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	onRestore_Complete(data: any) {
		this.PersonPhoto = data;

		if (this.PersonPhoto.HasPhoto == true) {
			// Has A Photo In CAASS
			this.cropperImageBase64 = this.PersonPhoto.ImageData_Raw;
			this.isImageFromCAASS = true;
			this.isImageFromCAASSRestore = true;
			this.isUpdateRaw = false;
			this.isDisablePhotoSave = false;

			this.filterGrayscale = false;
			this.filterBrightness = 0;
			this.filterContrast = 0;
			this.ApplyFilters();
		} else {
			// Has No Photo IN CAASS
			this.cropperImageBase64 = "";
			this.cropperCroppedWorkImage = "";
			this.isImageFromCAASS = true;
			this.isImageFromCAASSRestore = true;
			this.isUpdateRaw = false;
			this.isDisablePhotoSave = false;
		}

		this.isAiProcessed = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onExport
	//
	//-----------------------------------------------------------------------------------------------------
	onExport() {
		const MAX_SIZE = 640;
		let _this = this;
		let img = document.createElement("img");

		img.onload = function () {
			let width = img.width;
			let height = img.height;

			if (width >= height) {
				// Landscape
				height = Math.round(img.height * (MAX_SIZE / img.width));
				width = MAX_SIZE;
			} else {
				// Portrait
				width = Math.round(img.width * (MAX_SIZE / img.height));
				height = MAX_SIZE;
			}

			let canvas = document.createElement("canvas");

			canvas.width = width;
			canvas.height = height;

			let ctx = canvas.getContext("2d");

			ctx.drawImage(img, 0, 0, width, height);

			let ExportImage: any = canvas.toDataURL("image/jpeg");

			const dlink: HTMLAnchorElement = document.createElement("a");

			if (_this.SelectedPerson.PersonID > 0 && _this.SelectedPerson.DesignatorID != "") {
				dlink.download = _this.SelectedPerson.DesignatorID + ".jpg"; // the file name
			} else {
				dlink.download = "CAASSPhoto.jpg"; // the file name
			}

			dlink.href = ExportImage;
			dlink.click(); // this will trigger the dialog window
			dlink.remove();
		};

		img.src = this.cropperCroppedWorkImage;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	cropperImageLoaded
	//
	//-----------------------------------------------------------------------------------------------------
	cropperImageLoaded(image: any) {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	cropperReady
	//
	//-----------------------------------------------------------------------------------------------------
	cropperReady() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	cropperLoadImageFailed
	//
	//-----------------------------------------------------------------------------------------------------
	cropperLoadImageFailed() {}

	//-----------------------------------------------------------------------------------------------------
	//
	//	cropperImageCropped
	//
	//-----------------------------------------------------------------------------------------------------
	cropperImageCropped(event: ImageCroppedEvent) {
		var ImgData = "";

		if (event.base64 != undefined) {
			ImgData = event.base64;
		} else if (event.objectUrl != undefined) {
			ImgData = event.objectUrl;
		}

		this.cropperCroppedImage = ImgData;
		this.cropperCroppedWorkImage = ImgData;
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	setGrayscaleValue
	//
	//-----------------------------------------------------------------------------------------------------
	setGrayscaleValue(event: any) {
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	setBrightnessValue
	//
	//-----------------------------------------------------------------------------------------------------
	setBrightnessValue(event: any) {
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	setContrastValue
	//
	//-----------------------------------------------------------------------------------------------------
	setContrastValue(event: any) {
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ApplyFilters
	//
	//-----------------------------------------------------------------------------------------------------
	ApplyFilters() {
		let _this = this;
		let img = document.createElement("img");

		img.onload = function () {
			let canvas = document.createElement("canvas");

			canvas.width = img.width;
			canvas.height = img.height;

			let ctx = canvas.getContext("2d");

			ctx!.drawImage(img, 0, 0);

			let imageData = ctx!.getImageData(0, 0, Number(img.width), Number(img.height));
			let data = imageData.data;

			if (_this.filterGrayscale == true) {
				_this.applyGrayscale(data);
			}
			_this.applyBrightness(data, _this.filterBrightness);
			_this.applyContrast(data, _this.filterContrast);

			ctx!.putImageData(imageData, 0, 0);

			_this.cropperCroppedWorkImage = canvas.toDataURL("image/jpeg");
		};

		img.src = this.cropperCroppedImage;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	applyGrayscale
	//
	//-----------------------------------------------------------------------------------------------------
	applyGrayscale(data: any) {
		var d = data;
		for (var i = 0; i < d.length; i += 4) {
			var r = d[i];
			var g = d[i + 1];
			var b = d[i + 2];
			// CIE luminance for the RGB
			// The human eye is bad at seeing red and blue, so we de-emphasize them.
			var v = 0.2126 * r + 0.7152 * g + 0.0722 * b;
			d[i] = d[i + 1] = d[i + 2] = v;
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	applyBrightness
	//
	//-----------------------------------------------------------------------------------------------------
	applyBrightness(data: any, brightness: number) {
		for (var i = 0; i < data.length; i += 4) {
			data[i] += 255 * (brightness / 100);
			data[i + 1] += 255 * (brightness / 100);
			data[i + 2] += 255 * (brightness / 100);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	applyContrast
	//
	//-----------------------------------------------------------------------------------------------------
	applyContrast(data: any, contrast: number) {
		var factor = (259.0 * (contrast + 255.0)) / (255.0 * (259.0 - contrast));

		for (var i = 0; i < data.length; i += 4) {
			data[i] = this.truncateColor(factor * (data[i] - 128.0) + 128.0);
			data[i + 1] = this.truncateColor(factor * (data[i + 1] - 128.0) + 128.0);
			data[i + 2] = this.truncateColor(factor * (data[i + 2] - 128.0) + 128.0);
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onBrightnessReset
	//
	//-----------------------------------------------------------------------------------------------------
	onBrightnessReset() {
		this.filterBrightness = 0;
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onContrastReset
	//
	//-----------------------------------------------------------------------------------------------------
	onContrastReset() {
		this.filterContrast = 0;
		this.ApplyFilters();
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	truncateColor
	//
	//-----------------------------------------------------------------------------------------------------
	truncateColor(value: number) {
		if (value < 0) {
			value = 0;
		} else if (value > 255) {
			value = 255;
		}

		return value;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onSave
	//
	//-----------------------------------------------------------------------------------------------------
	onSave() {
		if (this.SelectedPerson.PersonID > 0) {
			if (this.cropperCroppedWorkImage.length > 20) {
				this.ResizeImageAndUpload();
			} else {
				this.confirmationService.confirm({
					acceptLabel: "Ok",
					rejectVisible: false,
					message: "Please take a photo or load an image.",
					header: "No photo to save",
					icon: "fa fa-external-link",
					accept: () => {},
					reject: () => {},
				});
			}
		} else {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Please select a person.",
				header: "Person not selected",
				icon: "fa fa-external-link",
				accept: () => {},
				reject: () => {},
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ResizeImageAndUpload
	//
	//-----------------------------------------------------------------------------------------------------
	ResizeImageAndUpload() {
		const MAX_SIZE = 640;

		let _this = this;
		let img = document.createElement("img");

		img.onload = function () {
			let width = img.width;
			let height = img.height;

			if (width >= height) {
				// Landscape
				height = Math.round(img.height * (MAX_SIZE / img.width));
				width = MAX_SIZE;
			} else {
				// Portrait
				width = Math.round(img.width * (MAX_SIZE / img.height));
				height = MAX_SIZE;
			}

			let canvas = document.createElement("canvas");

			canvas.width = width;
			canvas.height = height;

			let ctx = canvas.getContext("2d");

			ctx.drawImage(img, 0, 0, width, height);

			let obj: wsPhotoStationPhotoUploadInfoParm = {
				PersonID: _this.SelectedPerson.PersonID,
				isUpdateRaw: _this.isUpdateRaw,
				ImageData_Normal: canvas.toDataURL("image/jpeg"),
			};

			let PersonPhotoUpload: wsPhotoStationPhotoUploadInfoParm[] = [];
			PersonPhotoUpload.push(obj);

			//
			//	Upload Edited Image
			//
			console.log("Starting image edit upload..", new Date().toLocaleTimeString("en-US"));
			_this.isDisablePhotoSave = true;
			_this.dataService.PhotoStationPhotoUpload(PersonPhotoUpload[0]).subscribe((data) => _this.PhotoStationPhotoUpload_Callback(data));
		};

		img.src = this.cropperCroppedWorkImage;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoStationPhotoUpload_Callback
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoStationPhotoUpload_Callback(data: any) {
		console.log("Image edit upload complete..", new Date().toLocaleTimeString("en-US"));
		this.isUpdateRaw = false;
		this.isDisablePhotoSave = false;

		//
		//	Refresh Person Selector Image
		//
		this.personselectorService.ThumbnailRefresh("Refresh");
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onPrint
	//
	//-----------------------------------------------------------------------------------------------------
	onPrint() {
		if (this.SelectedSchool.SchoolID > 0 && this.SelectedPerson.PersonID > 0) {
			var ref = this.dialogService.open(PrintComponent, {
				header: "Print",
				width: "500px",
				data: {
					UserPersonID: this.user.personID,
					SchoolID: this.SelectedSchool.SchoolID,
					PersonID: this.PhotoStationData.PersonID,
					Name: this.PhotoStationData.Name,
					IsStaff: this.PhotoStationData.IsStaff,
				},
			});
			ref.onClose.subscribe((response) => {
				if (response == 1) {
				}
			});
		} else {
			this.confirmationService.confirm({
				acceptLabel: "Ok",
				rejectVisible: false,
				message: "Please select a person.",
				header: "Person not selected",
				icon: "fa fa-external-link",
				accept: () => {},
				reject: () => {},
			});
		}
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	AIColorPickerGetDefaultAIColor_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	AIColorPickerGetDefaultAIColor_Complete(data: any) {
		let rAiBackgroundColor: wsAiColorPickerDefaultAIColorInfo = data;
		this.AiBackgroundColor = rAiBackgroundColor.DefaultAIColor;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onColorPickerOk
	//
	//-----------------------------------------------------------------------------------------------------
	onColorPickerOk() {
		var PresetAIColorList: wsAiPresetColorInfo[] = [];
		
		this.AiPresetColors.forEach((value) => {
			let AiColor: wsAiPresetColorInfo = {Color: value};
			
			if (AiColor.Color.substring(0,1) != "#")
			{
				//
				//	User Added Colors return a string 'rgb(xxx,xxx,xxx)' in decimal not '#xxxxxx' in HEX.
				//	We must convert to a HEX string.
				//
				let rgbValues = AiColor.Color
				.substring(4, AiColor.Color.length - 1)
				.split(",")
				.map(Number);				

				let hexColor = this.rgbToHex(rgbValues[0],rgbValues[1],rgbValues[2]);
				AiColor.Color = hexColor;

			}
			
			PresetAIColorList = [...PresetAIColorList, AiColor];
			
	   	}); 

		let parms: wsAiColorPickerInfo = {
			SchoolID: this.SelectedSchool.SchoolID,
			DefaultAIColor: this.AiBackgroundColor,
			PresetAIColorList: PresetAIColorList
		};

		//
		// Update Presets in CAASS and Set Default
		//
		this.dataService.AIColorPickerUpdate(parms).subscribe((data) => this.onColorPickerOk_Complete(data));			
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	rgbToHex
	//
	//-----------------------------------------------------------------------------------------------------	
	rgbToHex(r: number, g: number, b: number): string {
		return "#" + this.componentToHex(r) + this.componentToHex(g) + this.componentToHex(b);
	}
	  
	//-----------------------------------------------------------------------------------------------------
	//
	//	componentToHex
	//
	//-----------------------------------------------------------------------------------------------------	
	componentToHex(c: number): string {
		const hex = c.toString(16);
		return hex.length === 1 ? "0" + hex : hex;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onColorPickerOk_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	onColorPickerOk_Complete(data: any) {
		this.isAiShowColorPicker = false;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onColorPickerCancel
	//
	//-----------------------------------------------------------------------------------------------------
	onColorPickerCancel() {
		this.AiBackgroundColor = this.AiColorPicker.DefaultAIColor;
		this.isAiShowColorPicker = false;		
	}	

	//-----------------------------------------------------------------------------------------------------
	//
	//	onColorPickerOpen
	//
	//-----------------------------------------------------------------------------------------------------
	onColorPickerOpen() {
		let parms: wsAiColorPickerParmInfo = {
			SchoolID: this.SelectedSchool.SchoolID
		};

		this.dataService.AIColorPickerGet(parms).subscribe((data) => this.onColorPickerOpen_Complete(data));		
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onColorPickerOpen
	//
	//-----------------------------------------------------------------------------------------------------
	onColorPickerOpen_Complete(data: any) {
		this.AiColorPicker = data;
		
		 if (this.AiColorPicker.PresetAIColorList.length > 0)
		 {
		 	var AiColors: string[] = [];

 		 	this.AiColorPicker.PresetAIColorList.forEach((value) => {
		 		AiColors = [...AiColors, value.Color];
		 	});  

		 	this.AiBackgroundColor = this.AiColorPicker.DefaultAIColor;
		 	this.AiPresetColors = (JSON.parse(JSON.stringify(AiColors)));
		 }
		
		this.isAiShowColorPicker = true;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAiRemoveBackground
	//
	//-----------------------------------------------------------------------------------------------------
	onAiRemoveBackground() {
		this.isAiProcessing = true;
		this.AiResetImage = this.cropperImageBase64;
		this.ApplyRemoveBackground();		
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ApplyRemoveBackground
	//
	//-----------------------------------------------------------------------------------------------------
	ApplyRemoveBackground() {
		let parms: wsPhotoAIUploadInfo = {
			BackgroundColor: this.AiBackgroundColor.toUpperCase(),
			PersonPhoto: this.cropperImageBase64
		};

		this.dataService.PhotoAIRemoveBackground(parms).subscribe((data) => this.ApplyRemoveBackground_Complete(data));		
	}	

	//-----------------------------------------------------------------------------------------------------
	//
	//	ApplyRemoveBackground_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ApplyRemoveBackground_Complete(data: any) {

		let rPhotoAIRemoveBackGroundInfo: wsPhotoAIUploadInfo = data;
		let PhotoBackgroundImage = rPhotoAIRemoveBackGroundInfo.PersonPhoto;

		this.PersonPhoto.ImageData_Normal = PhotoBackgroundImage;
		this.cropperImageBase64 = this.PersonPhoto.ImageData_Normal;
		
		this.isAiProcessing = false;
		this.isAiProcessed = true;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAiCreatePortrait
	//
	//-----------------------------------------------------------------------------------------------------
	onAiCreatePortrait() {
		this.isAiProcessing = true;
		this.AiResetImage = this.cropperImageBase64;
		this.ApplyCreatePortrait();		
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	ApplyCreatePortrait
	//
	//-----------------------------------------------------------------------------------------------------
	ApplyCreatePortrait() {
		let parms: wsPhotoAIUploadInfo = {
			BackgroundColor: this.AiBackgroundColor.toUpperCase(),
			PersonPhoto: this.cropperImageBase64
		};

		this.dataService.PhotoAICreatePortrait(parms).subscribe((data) => this.ApplyCreatePortrait_Complete(data));		
	}	
	
	//-----------------------------------------------------------------------------------------------------
	//
	//	ApplyCreatePortrait_Complete
	//
	//-----------------------------------------------------------------------------------------------------
	ApplyCreatePortrait_Complete(data: any) {
		let rPhotoAIRemoveBackGroundInfo: wsPhotoAIUploadInfo = data;
		let PhotoBackgroundImage = rPhotoAIRemoveBackGroundInfo.PersonPhoto;

		this.PersonPhoto.ImageData_Normal = PhotoBackgroundImage;
		this.cropperImageBase64 = this.PersonPhoto.ImageData_Normal;
		
		this.isAiProcessing = false;
		this.isAiProcessed = true;
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	onAIReset
	//
	//-----------------------------------------------------------------------------------------------------
	onAIReset() {
		this.cropperImageBase64 = this.AiResetImage;
		this.isAiProcessed = false;		
	}

  //-----------------------------------------------------------------------------------------------------
	//
	//	isSigWeb_1_7_2_0_OrGreater_Installed
	//
	//----------------------------------------------------------------------------------------------------- 
	isSigWeb_1_7_2_0_OrGreater_Installed(sigWebVer: any)   
	{
	  var minSigWebVersionPreflightResponsesSupport = "1.7.2.0";
	  
	  if(this.isOlderSigWebVersionInstalled(minSigWebVersionPreflightResponsesSupport, sigWebVer))
	  {
		  console.log("SigWeb version 1.7.2.0 or higher not installed.");
		  alert("SigWeb version 1.7.2.0 or higher not installed.");
		  return false;
	  }
  
	  return true;
	}
  
	//-----------------------------------------------------------------------------------------------------
	  //
	  //	isOlderSigWebVersionInstalled
	  //
	  //-----------------------------------------------------------------------------------------------------    
	isOlderSigWebVersionInstalled(cmprVer: any, sigWebVer: any)
	{    
		return this.isOlderVersion(cmprVer, sigWebVer);
	}
  
	//-----------------------------------------------------------------------------------------------------
	  //
	  //	isOlderVersion
	  //
	  //-----------------------------------------------------------------------------------------------------    
	isOlderVersion (oldVer: any, newVer: any) 
	{
	  const oldParts = oldVer.split('.');
	  const newParts = newVer.split('.');
	
	  for (var i = 0; i < newParts.length; i++) 
	  {
		const a = parseInt(newParts[i]) || 0;
		const b = parseInt(oldParts[i]) || 0;
		if (a < b) return true;
		if (a > b) return false;
	  }
  
	  return false;
	}
  
	//-----------------------------------------------------------------------------------------------------
	  //
	  //	onSign
	  //
	  //-----------------------------------------------------------------------------------------------------    
	onSign()
	{
	  if(IsSigWebInstalled())
	  {
		ClearTablet();
		this.bioSigData = null;
		this.bioSigDataBase64_jpg = null;
		this.bioSigDataBase64_web = null;
  
		SetDisplayXSize( 500 );
		SetDisplayYSize( 100 );
		SetTabletState(0, this.tmr);
		SetJustifyMode(0);
	  
		if(this.tmr == null)
		{
		  this.tmr = SetTabletState(1, this.SigElement, 50);
		}
		else
		{
		  SetTabletState(0, this.tmr);
		  this.tmr = null;
		  this.tmr = SetTabletState(1, this.SigElement, 50);
		}

		var sigState : any;
		sigState = GetTabletState();
		console.log(sigState);
		if (sigState == 0)
		{
		  console.log("Unable to communicate with TOPAZ Signature pad. Please confirm that TOPAZ Signature pad is plugged in.");
		  alert("Unable to communicate with TOPAZ Signature pad. Please confirm that TOPAZ Signature pad is plugged in.");
		}

	  } 
	  else
	  {
		console.log("Unable to communicate with TOPAZ SigWeb. Please confirm that SigWeb is installed and running on a Windows PC.");
		alert("Unable to communicate with TOPAZ SigWeb. Please confirm that SigWeb is installed and running on a Windows PC.");
	  }
	}  
  
	//-----------------------------------------------------------------------------------------------------
	//
	//	onClear
	//
	//-----------------------------------------------------------------------------------------------------    
onClear()
	{
	  ClearTablet();
  
	  this.bioSigData = null;
	  this.bioSigDataBase64_jpg = null;
	  this.bioSigDataBase64_web = null;    
	}
  
	//-----------------------------------------------------------------------------------------------------
	//
	//	onSaveSig
	//
	//-----------------------------------------------------------------------------------------------------    
	onSaveSig()
	{
		if(NumberOfTabletPoints() == 0)
		{
			alert("Please sign before continuing");
		}
		else
		{
			SetTabletState(0, this.tmr);

			//
			//  Return TOPAZ-format Sig string
			//
			SetSigCompressionMode(1);

			this.bioSigData = GetSigString();

			//
			// Return JPG Byte Array Converted to BASE64 string
			//
			SetImageXSize(500);
			SetImageYSize(100);
			SetImagePenWidth(5);

			Access411_GetSigImageB64(this.Access411_GetSigImageB64_Callback, this);
		}    
	}
  
	//-----------------------------------------------------------------------------------------------------
	//
	//	Access411_GetSigImageB64_Callback - Returns base64 JPG image string 
	//
	//-----------------------------------------------------------------------------------------------------    
	Access411_GetSigImageB64_Callback(data: any, _this: any)
	{
		_this.bioSigDataBase64_jpg = data;
		_this.bioSigDataBase64_web = "data:image/jpeg;charset=utf-8;base64," + data

		_this.onSigCaptured();
	}  
  
	//-----------------------------------------------------------------------------------------------------
	//
	//	onSigCaptured
	//
	//-----------------------------------------------------------------------------------------------------    
	onSigCaptured()
	{
		//console.log("bioSigData: " + this.bioSigData);
		//console.log("bioSigDataBase64_jpg: " + this.bioSigDataBase64_jpg);
		//console.log("bioSigDataBase64_web: " + this.bioSigDataBase64_web);

		let obj: wsPhotoStationSignatureUploadInfoParm = {
			PersonID: this.SelectedPerson.PersonID,
			SignatureData: this.bioSigDataBase64_web
		};

		//
		//	Upload Edited Image
		//
		if (this.SelectedPerson.PersonID > 0)
		{
			this.isDisableSignatureSave = true;
			this.dataService.PhotoStationSignatureUpload(obj).subscribe((data) => this.PhotoStationSignatureUpload_Callback(data));
		}
	}
  
	//-----------------------------------------------------------------------------------------------------
	//
	//	PhotoStationSignatureUpload_Callback
	//
	//-----------------------------------------------------------------------------------------------------
	PhotoStationSignatureUpload_Callback(data: any) {

		this.PhotoStationSignatureData = data;
		this.PhotoStationData.SignatureData = this.PhotoStationSignatureData.SignatureData

		if (this.PhotoStationData.SignatureData == null)
		{
			this.isSigOnFile = false;
		}
		else
		{
			if (this.PhotoStationData.SignatureData.length > 100)
			{
				this.isSigOnFile = true;
			}
			else
			{
				this.isSigOnFile = false;
			}
		}

		//
		//	Clear Tablet And Prep For Next Signature
		//
		this.onSign()

		//
		//	Done
		//
		this.isDisableSignatureSave = false;
		console.log("signature upload complete..", new Date().toLocaleTimeString("en-US"));
	}

	//-----------------------------------------------------------------------------------------------------
	//
	//	Add New Method Here
	//
	//-----------------------------------------------------------------------------------------------------
}
